import { List } from "../Components/index.js";

export default [
    {
        path: "/source-money-list",
        component: List,
        name: "source-money-list",
        meta: {
            requiresAuth: true,
        },
    },
];
